import React, { useMemo } from "react";
import { useData } from "../../context/DataContext";
import { useAuth } from "../../context/AuthContext";
import { userMatchesField, cellText } from "../../utils/helpers";
import TaskTable from "../../components/TaskTable";
import { USER_TABLE } from "../../context/DataContext";

export default function PendingTasks() {
  const { userRecords, loading } = useData();
  const { user } = useAuth();

  const allMine = useMemo(() =>
    userRecords.filter((r) => r.user_id === user?.userId),
    [userRecords, user]
  );

  const pending = useMemo(() =>
    allMine.filter((r) => !r.fields?.["My Completion"]),
    [allMine]
  );

  if (loading && userRecords.length === 0) return <div className="loading-box"><div className="spinner" /><span>Loading...</span></div>;

  return (
    <div className="fade-in">
      <div className="page-header">
        <h1>⏳ Pending Tasks</h1>
        <p>Tasks that are not yet completed — {pending.length} records</p>
      </div>
      <TaskTable 
        tableId={USER_TABLE} 
        canComplete 
        records={pending} 
        emptyMsg="No pending tasks. Great job! 🎉" 
        statusOptionsOverride={["⬜ Not Started", "🟡 In Progress"]}
      />
    </div>
  );
}
